import z from 'zod';

import { RequiredMessage } from './util/RequiredMessage';

export const AviationColorCodes = [
  'UNASSIGNED',
  'NIL',
  'GREEN',
  'YELLOW',
  'ORANGE',
  'RED',
] as const;

export const AviationColorCodeZod = z.enum(AviationColorCodes, RequiredMessage);

export type AviationColorCode = z.infer<typeof AviationColorCodeZod>;

export const AviationColorCodeText: Record<AviationColorCode, string> = {
  UNASSIGNED: 'Unassigned',
  NIL: 'Nil',
  GREEN: 'Green',
  YELLOW: 'Yellow',
  ORANGE: 'Orange',
  RED: 'Red',
};
